<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<div class="mh-time-top">
				<b-row no-gutters>
					<b-col align-self="center" md="12">
						<h2>Available Shifts</h2>
					</b-col>
				</b-row>
			</div>

			<div class="mh-middle-container">
				<div class="mh-time-entries-top mh-time-off">
					<b-row class="m-0">
						<b-col v-if="records.length != 0" cols="12" class="p-0 mt-3">
							<div class="table-reponsive mh-entries-list">
								<div class="dataTables_wrapper no-footer">
									<data-table v-bind="bindings"
												:showPerPage="false"
												:showEntriesInfo="false"
												:showSearchFilter="false"
												:showPagination="true"
												:showDownloadButton="false"
												:text="{ emptyTableText: '' }"
												sortingMode="single"
												tableClass="table table-curved dataTable light"
												ref="dataTable" />
								</div>
							</div>
						</b-col>
						<b-col v-else cols="12" class="no-time-entries-container text-center p-0 pt-4">
							<img src="../assets/images/no-time-entries.png" class="mb-5" />
							<div class="title mb-2">No available shifts</div>
						</b-col>
					</b-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import SortingIcon from "./partials/SortingIcon"
	import HtmlColumn from "./partials/HtmlColumn"
	import TableRowActions from "./partials/TableRowActions"
	import { bus } from "./../main"
	import moment from "moment"

	export default {
		name: 'AvailableShiftsContent',
		components: {
			ContentTitle,
			SortingIcon,
			HtmlColumn,
			TableRowActions
		},
		data: function () {
			return {
				
			}
		},
		mounted: function () {
			this.$store.dispatch("Shifts/getAvailableShifts")

			bus.$off('availableShiftsPickup')
			bus.$on('availableShiftsPickup', obj => { this.availableShiftsPickup(obj) })
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			availableShifts: function () {
				return this.$store.state.Shifts.availableShifts
			},
			records: function () {
				return this.availableShifts
					.map(x => {
						return {
							id: x.servicescheduleid,
							date: moment(x.servicedate, "D/MM/YYYY h:mm:ss A").format("DD MMM, ddd"),
							time: x.shift,
							participant: x.clientfullname,
							item: x.shifttask,
							location: x.clientfulladdress,
							servicedate: x.servicedate,
							serviceenddate: x.serviceenddate,
							icons: [
								{
									class: "thumbs-up",
									title: "Pickup",
									emit: "availableShiftsPickup",
									disabled: true
								}
							]
						}
					})
			},
			columns: function () {
				var columns = [
					{ key: "date", title: "Date", searchable: true, sortable: true, component: HtmlColumn },
					{ key: "time", title: "Time In-Out", searchable: true, sortable: true, component: HtmlColumn },
					{ key: "participant", title: "Participant", searchable: true, sortable: true, component: HtmlColumn },
					{ key: "item", title: "Item", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:15vw;" },
					{ key: "location", title: "Location", searchable: true, sortable: true, component: HtmlColumn, style: "display: block;width:10vw;" },
					{ key: "", title: "", component: TableRowActions }
				]

				return columns
			},
			bindings: function () {
				return {
					SortingIconComponent: SortingIcon,
					columns: this.columns,
					data: this.records
				}
			}
		},
		methods: {
			availableShiftsPickup: function (shift) {
				this.$store.commit("Confirmation/show", {
					text: `Are you sure you want to pickup the shift for <b>${shift.participant}</b> on <b>${moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A").format("ddd,DD MMM YYYY h:mm a")}</b> to <b>${moment(shift.serviceenddate, "DD/MM/YYYY h:mm:ss A").format("ddd,DD MMM YYYY h:mm a")}</b>?`,
					okCallback: () => {
						this.$store.dispatch(
							"Shifts/pickupShift",
							shift.id)
							.then(() => {
								this.$store.commit("Toasts/showSuccess", { title: "Assigned", content: "Shift assigned" })
								this.$store.dispatch("Shifts/getAvailableShifts")
							})
					},
					cancelCallback: null
				})
			}
		}
	};
</script>